import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface WrapperProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>`
  display: -ms-grid;
  display: grid;
  column-gap: 2em;
  -ms-grid-columns: 2fr 2fr 80px;
  grid-template-columns: 2fr 2fr 80px;
`;

interface HiddenProps {
  isHidden?: boolean;
  children?: ReactNode;
}

export const Hidden = styled.div<HiddenProps>`
  margin-top: 10px;

  ${({ isHidden }) =>
    isHidden &&
    css`
      visibility: hidden;
    `}
`;
